import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import { withApi } from '../Providers/WebServiceProvider.js';

class LogoutButton extends Component
{
	constructor (props) {
		super(props);

		this.state = {
			loggedOut: false
		}

		this.onLogout = this.onLogout.bind(this);
	}

	onLogout () {
		const that = this;
		this.setState({ loggedOut: true }, function () {
			that.props.webServiceContext.auth.setUser(false).catch(() => {});
		});
	}

	render () {
		if (this.state.loggedOut) 
		{
			return (
				<Redirect to={{pathname: "/"}} />
			);
		} 
		else 
		{
			return (
				<input type="button" value="Logout" className="button is-danger is-outlined" onClick={this.onLogout} />
			);
		}
	}
}

export default withApi(LogoutButton);


// WEBPACK FOOTER //
// ./src/Components/LogoutButton.js